module.exports = __webpack_public_path__ + "img/customize_access.474c5085.svg";